<div class="modal-body">
  <div class="fgbcl-game-predictor-thanks-for-playing-model-section">
    <div class="fgbcl-game-predictor-play-modal-good-luck-text">{{ 'fgbcl.game.predictor.good.luck.text' | translate }}</div>
    <div class="fgbcl-game-predictor-play-modal-description">
      {{ 'fgbcl.game.predictor.thanks.for.playing.text' | translate }}
    </div>
    <div class="fgbcl-games-predictor-question-section-countdown-modal">
      <div class="fgbcl-games-predictor-countdown-end-text">{{ 'fgbcl.game.predictor.ends.text' | translate }}:</div>
      <fgbcl-countdown-v2 [endDateTime]="endDate" completeText="Ended"></fgbcl-countdown-v2>
    </div>
    <fgbcl-social-share-modal
      shareType="scorecards"
      [urlPage]="redirectPageURL"
      [loyaltyCategoryType]="loyaltyCategoryType"
    ></fgbcl-social-share-modal>

    <div class="fgbcl-game-predictor-edit-back-button-sections">
      <button
        (click)="closeModalButton('hub')"
        class="fgbcl-predictor-thanks-for-playing-model-button fgbcl-game-back-to-game-button"
      >
        {{ 'fgbcl.game.result.predictor.hub.button.text' | translate }}
      </button>
      <button (click)="closeModalButton('edit')" class="fgbcl-predictor-thanks-for-playing-model-button fgbcl-game-edit-button">
        {{ 'fgbcl.game.edit.predictor.button.text' | translate }}
      </button>
    </div>
  </div>
</div>
